import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'formly-wrapper-panel',
  template: `
    <div class="first-container">
      <div class="first-header">
        <div>{{ to.label }}</div>
      </div>
      <div class="first-content">
        <ng-container #fieldComponent></ng-container>
      </div>
    </div>
  `,
})
export class FirstWrapperComponent extends FieldWrapper {}
